/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const AvatarFilled = (props: any) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="5 5 15 15" stroke="none" fill="inherit">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.3379 12.5182C14.051 12.43 13.9617 11.912 14.1757 11.7016C14.902 10.9877 15.3745 9.89273 15.3745 8.91892C15.3745 8.91889 15.3746 8.91887 15.3746 8.91887C15.3746 8.91887 15.3746 8.91885 15.3746 8.91882C15.3746 7.87604 14.8239 6.9124 13.9299 6.39103C13.036 5.86966 11.9345 5.86966 11.0405 6.39103C10.1464 6.91246 9.5957 7.87609 9.5957 8.91887C9.5957 9.89558 10.071 10.9942 10.801 11.7079C11.0156 11.9177 10.928 12.4361 10.6415 12.5253C8.76358 13.11 7 14.4763 7 16.0638C7 18.0147 8.10518 18.0106 11.5609 17.9979C11.8565 17.9968 12.1692 17.9956 12.5 17.9956C12.8196 17.9956 13.1232 17.9968 13.4112 17.998C16.7397 18.0112 18 18.0162 18 16.0638C18 14.4669 16.2235 13.0982 14.3379 12.5182Z" fill="inherit"/>
</svg>
);

export default AvatarFilled;